import Api from '@api/api';
import { JwtResponse, LoginRequest, RegisterRequest } from '../schema/auth';
import { UserResponse } from '@/schema/user';

const AuthApi = {
  login(data: LoginRequest) {
    return Api.post<JwtResponse>('/auth/login', data);
  },

  register(data: RegisterRequest) {
    return Api.post<UserResponse>('/auth/register', data);
  },

  refresh() {
    return Api.post<JwtResponse>('/auth/refresh', {});
  },

  logout() {
    return Api.post<void>('/auth/logout', {});
  },
};

export default AuthApi;
